/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import React from "react";
import { Box } from "@mui/material";
import ContentLoader from "react-content-loader";

export const CostBoxLoader = () => (
  <>
    <Box sx={{ display: { xs: "none", sm: "block" } }}>
      <ContentLoader height={270} width={500} speed={2} backgroundColor="#f3f3f3" foregroundColor="#ecebeb">
        <rect x="20" y="30" rx="4" ry="4" width="460" height="4" />
        <rect x="20" y="50" rx="4" ry="4" width="460" height="4" />
        <rect x="20" y="100" rx="4" ry="4" width="220" height="4" />
        <rect x="20" y="150" rx="4" ry="4" width="220" height="4" />
        <rect x="260" y="100" rx="4" ry="4" width="220" height="4" />
        <rect x="260" y="150" rx="4" ry="4" width="220" height="4" />
        <rect x="20" y="190" rx="4" ry="4" width="460" height="40" />
      </ContentLoader>
    </Box>
    <Box sx={{ display: { xs: "block", sm: "none" } }}>
      <ContentLoader height={300} width={300} speed={2} backgroundColor="#f3f3f3" foregroundColor="#ecebeb">
        <rect x="10" y="20" rx="3" ry="3" width="240" height="6" />
        <rect x="10" y="40" rx="3" ry="3" width="200" height="6" />
        <rect x="10" y="60" rx="3" ry="3" width="120" height="6" />
        <rect x="10" y="115" rx="3" ry="3" width="280" height="4" />
        <rect x="10" y="170" rx="3" ry="3" width="280" height="4" />
        <rect x="10" y="220" rx="3" ry="3" width="280" height="4" />
        <rect x="10" y="240" rx="4" ry="4" width="280" height="40" />
      </ContentLoader>
    </Box>
  </>
);
